// extracted by mini-css-extract-plugin
export default {"InquiryListPage":"InquiryListPage_InquiryListPage__CfHsi"};